import styled from '@emotion/styled'
import {theme} from '../../../../../../accountManagement/theme'

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${theme.space[3]};
  flex-shrink: 0;
`

export const LabelBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`

export const PinIconSlot = styled.span`
  display: flex;
  align-items: center;
  color: ${theme.colors.border.focus};
`

export const LabelText = styled.span`
  display: flex;
  flex-direction: column;
  line-height: 1.2;

  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.text.primary};
`

export const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  min-width: 200px;
  min-height: 38px;
  padding: 6px ${theme.space[3]};

  background: ${theme.colors.input.bg};
  border: 1px solid #5378fc;
  border-radius: ${theme.radii.lg};
  cursor: pointer;

  &:hover {
    border-color: #5378fc;
  }
`

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px ${theme.space[2]};

  background: #dfe5f7;
  border-radius: ${theme.radii.lg};

  overflow: hidden;
  max-width: 220px;
`

export const ChipLabel = styled.span`
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.text.primary};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ChevronSlot = styled.span`
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  color: ${theme.colors.text.muted};
  transform: rotate(${({open}) => (open ? '180deg' : '0deg')});
  transition: transform ${theme.transitions.normal};
`

export const OptionsPanel = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  min-width: 240px;

  max-height: 240px;
  overflow-y: auto;
  margin-top: 6px;
  padding: ${theme.space[1]};

  background: ${theme.colors.bg.primary};
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.lg};
  box-shadow: ${theme.shadows.md};

  z-index: ${theme.zIndex.dropdown};
`

export const OptionRow = styled.button`
  display: flex;
  align-items: center;
  gap: ${theme.space[2]};
  width: 100%;
  text-align: left;

  padding: ${theme.space[2]} ${theme.space[3]};

  background: transparent;
  border: none;
  border-radius: ${theme.radii.md};
  cursor: pointer;

  &:hover {
    background: ${theme.colors.bg.tertiary};
  }
`

export const OptionLabel = styled.span`
  font-size: ${theme.fontSizes.sm};
  color: ${theme.colors.text.primary};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
